import React, { Component } from 'react';
import Vas from '../Vas';
import {LinkButton} from 'component-lib';

class NoPayment extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
    }

   render()
    {
        return ( <div className={"contractContainer"}>
          <div className={"form"} style={{maxWidth:'500px', textAlign:'justify'}}>
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2><div style={{ textAlign:"center" }}>{Vas.Resources.Labels["NoPaymentTechnicalReasons"]}</div></h2></th>
                </tr>
              </thead>
              <tbody>
              <tr>
                <td style={{ width:'205px', fontSize:'14px', textAlign: 'right' }}>
                  <div  style={{ paddingRight: '5px' }} className={'ConfirmationLabel'}>{Vas.Resources.Labels["LinkLoginFemininum"]}</div>
                </td>
                <td style={{ textAlign: 'left' }}>
                  <LinkButton
                  Text={Vas.Resources.Labels["CreateMethodOfPaymentLink"]}
                  Id={"LinkCreatePayment"}
                  OnClick={()=>{Vas.GetView("CreatePayment", { CustomerId :this.props.match.params.CustomerId, NewContract : this.props.match.params.NewContract , PaymentId : "000000" }, true);}} /></td>
              </tr>
              </tbody>
            </table> 
          </div>
        </div>);
    }
}
export default NoPayment;
